import { errorsManager } from "./services/errors/errorsManager"

const localStorageGetItem = (key) => {
  try {
    return window.localStorage.getItem(key)
  } catch (err) {
    // normalize + send to Bugsnag
    errorsManager.reportLocalStorageError(err)
    return null
  }
}

const localStorageSetItem = (key, value) => {
  try {
    window.localStorage.setItem(key, value)
  } catch (err) {
    // normalize + send to Bugsnag
    errorsManager.reportLocalStorageError(err)
  }
}

const localStorageRemoveItem = (key) => {
  try {
    window.localStorage.removeItem(key)
  } catch (err) {
    errorsManager.reportLocalStorageError(err)
  }
}

//

const store = (key, values) => {
  key = `${pipelineConfig.pathPrefix}:${key}`

  localStorageSetItem(key, JSON.stringify(values))
}

const getStoreByKeyValue = (key, valueKey) => {
  key = `${pipelineConfig.pathPrefix}:${key}`
  const data = localStorageGetItem(key) ?? null
  let store = null

  if (data) {
    store = JSON.parse(data)
  }
  if (store && store.values && valueKey && store.values[valueKey]) {
    return store.values[valueKey]
  }
  return store ?? null
}

const load = (key) => {
  key = `${pipelineConfig.pathPrefix}:${key}`

  const data = localStorageGetItem(key)

  if (data) {
    return JSON.parse(data)
  } else {
    return null
  }
}

function getLocalStorageValue(storageKey, valueName) {
  const data = load(storageKey)

  if (!data || !data.values || !valueName) return null

  return data.values[valueName]
}


export {
  localStorageGetItem,
  localStorageSetItem,
  localStorageRemoveItem,
  store, 
  load, 
  getStoreByKeyValue, 
  getLocalStorageValue,
}
